import ImportFormFieldNames from '@lib/enums/fieldNames/importFormFieldNames';
import { getDataImportKindOptionsByPermission } from '@lib/utils/dataImport';

export default function getDefaultValues({
  isSitesAvailable,
  isAssetsAvailable,
}: {
  isSitesAvailable: boolean;
  isAssetsAvailable: boolean;
}) {
  const typeOptions = getDataImportKindOptionsByPermission({
    isSitesAvailable,
    isAssetsAvailable,
  });
  const type = typeOptions?.[0];
  return {
    [ImportFormFieldNames.FileUploadErrors]: undefined,
    [ImportFormFieldNames.FileUpload]: undefined,
    [ImportFormFieldNames.IgnoreErrors]: undefined,
    [ImportFormFieldNames.Title]: undefined,
    [ImportFormFieldNames.Type]: typeOptions?.length === 1 ? type : undefined,
  };
}
